//特殊字符判断
export function isSpecialStr (rule, value, callback) {
    var re = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]")
    if (re.test(value)) {
      return callback(new Error('存在特殊字符,请重新输入!'));
    } else {
        callback();
    }
};

//输入数字
export function isNumber (rule, value, callback) {
    if (!Number.isInteger(value)) {
        callback(new Error('请输入数字'));
      } else {
        callback();
    }
};











// WEBPACK FOOTER //
// ./src/js/textverify.js